import type { StrapiCatalogCategory } from "~/types/strapi";

export function useStrapiCatalogCategory() {
  const { find } = useStrapiExtend();

  async function fetchCatalogCategory(
    uid: string,
  ): Promise<StrapiCatalogCategory | undefined> {
    const response = await find<StrapiCatalogCategory>("catalog-categories", {
      populate: "special_order.slug",
      pagination: { limit: 1, start: 0 },
      filters: { categoryUid: uid },
    });

    return response.data[0]?.attributes;
  }

  return {
    fetchCatalogCategory,
  };
}
